import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionButtons = [
    "add", 
    "remove", 
    "export"
  ];

  return <LmsTable
    actionButtons={actionButtons}
    apiSuffix="accounting/journal-entries"
    deleteSuffix="accounting/journal-entries"
    columnLabelsDictionary={{
      lpinterestJecreated: "LP Interest JE Created",
      nplsubStatus: "NPL Sub Status",
      revenueJecreated: "Revenue JE Created",
      yearMonth: "Year/Month"
    }}
    skipClick
  />;
};

const accountingJeFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getInputField("Year/Month", { name: "yearMonth", required: true, fieldType: GlobalConstants.InputTypes.YEAR_MONTH })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Select statuses that require NPL JE. All other Active status will not have NPL JE created", "metadata/list-loan-sub-statuses", { dropdownMultiple: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Funds", "orgs/list-fund-orgs", { dropdownMultiple: true, required: true })]);
  myForm.addGroupFields([
    myForm.getBlankField(),
    myForm.getCheckboxField("Create Revenue JE", { inline: true, width: 3, value: false, name: "createRevenueJe" }),
    myForm.getCheckboxField("Create LP Interest JE", { inline: true, width: 3, value: false, name: "createLPInterestJE" }),
    myForm.getCheckboxField("Adhoc", { inline: true, width: 3, value: false })
  ], { widths: 4 });

  myForm.addGroupFields([
    myForm.getBlankField(),
    myForm.getCheckboxField("Additional Interest", { inline: true, width: 3, value: false }),
    myForm.getCheckboxField("Interest Income", { inline: true, width: 3, value: false }),
    myForm.getCheckboxField("Origination Fee", { inline: true, width: 3, value: false })
  ], { widths: 4, isHidden: { createRevenueJe: false } });

  myForm.addGroupFields([
    myForm.getBlankField(),
    myForm.getCheckboxField("Processing Fee", { inline: true, width: 3, value: false }),
    myForm.getCheckboxField("Extension Fee", { inline: true, width: 3, value: false })
  ], { widths: 4, isHidden: { createRevenueJe: false } });

  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);
  return myForm;
};

const AddAccountingJeForm = () => {
  const handleSubmitValidation = async ( inputs ) => {
    const message = [] as string[];
    if (inputs.yearMonth.length < 6) {
      message.push("The Format of Year/Month field is incorrect.");
    }
    else {
      const year = parseInt(inputs.yearMonth.slice(0, 4));
      const month = parseInt(inputs.yearMonth.slice(inputs.yearMonth[4] === "-" ? 5 : 4));
      if (year < 1900 || year > 3000) {
        message.push("Please enter a valid year.");
      }

      if (month < 1 || month > 12) {
        message.push("Please enter a valid month.");
      }

      inputs.yearMonth = `${year}-${month < 10 ? `0${month}` : month}`;
    }
    
    if (inputs.createLPInterestJE === false && inputs.createRevenueJe === false) {
      message.push("Please select at least one of Revenue JE or LP Interest JE.");
    }

    if (message?.length) {
      return { errorMessage: message };
    }
    else {
      return { success: true };
    }
  };

  const myForm = accountingJeFormFields(new BCFormController({}, { 
    submitSuffix: "accounting/journal-entry", 
    blankWidth: 4,
  }));  
  
  const formActions = [
    { text: "Create JE", icon: GlobalConstants.Icons.SAVE, action: "save-close" },
    "close"
  ];

  return (<LmsFormGenerator 
    myForm={myForm} 
    actions={formActions} 
    handleSubmitValidation={handleSubmitValidation}
    onSubmitSuccessMessage={"JE's created successfully"}
    skipAutoCloseSuccessMessage
  />);
};

const LmsAccountingAccountingJe = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable />}
    {isAdd && <AddAccountingJeForm />}
  </>);
};

export default LmsAccountingAccountingJe;